<template>
  <div class="c-playlists-albums-info">
    <p class="curr-music-title">{{ data.name || data.albumTitleDisplay || '' }}</p>
    <p class="curr-music-desc">
      {{ data.description || data.albumDescription || '' }}
    </p>
    <p class="curr-music-info">
      <template v-if="route.name === 'explore-albums-info'">
        <span class="curr-music-info__label">ID</span>
        <span class="curr-music-info__id">{{ data.albumCode }}</span>
        <span class="curr-music-info__label">{{ $t('explore.type.labels') }}</span>
        <template v-for="(l, idx) of labelsList" :key="l.name + idx">
          <router-link class="curr-music-info__labels curr-music-info__labels--active" :to="{
              name: 'explore-labels-info', params: {
                id: l.labelUid
              }
            }" v-if="l.status === 'Activate'">{{ l.name }}</router-link>

          <span class="curr-music-info__labels" v-else>{{ l.name }}</span>
        </template>
        <span class="curr-music-info__label">{{ $t('explore.tags') }}</span>
        <span class="curr-music-info__tags">{{ albumsTags }}</span>
      </template>
    </p>
    <div class="divide-line"></div>
    <div class="music">
      <div class="music__music-player">
        <music-function
          :functionList="route.name === 'explore-albums-info' ? ['add', 'download', 'download-all', 'star', 'share-playlists'] : ['share-playlists', 'download-all']"
          :playType="route.name === 'explore-albums-info' ? 'album' : 'playlist'" showPlay :type="type" :data="data"
          :downloadAllType="route.name === 'explore-albums-info' ? 'album' : 'playlist'" />
      </div>
      <div class="music__more-info">
        <img class="music__more-info__icon" src="@/assets/mobile/icon_menu_info.svg" @click="openModal" />
      </div>
      <div class="music__other">
        <p class="music__other__detail" v-if="route.name === 'explore-playlists-info'">
          <span class="music__other__detail__label">{{ $t('explore.tags') }}</span>
          <span class="music__other__detail__category">{{ tags }}</span>
        </p>
        <p class="music__other__detail" v-if="route.name === 'explore-albums-info'">
          <span class="music__other__detail__label">{{ $t('explore.publicDate') }}</span>
          <span class="music__other__detail__release-date">{{ releaseDate(data?.releaseDate) }}</span>
        </p>
      </div>
    </div>
    <div class="tracks">
      <p class="tracks__text">{{ addCommas(tracksLength) }} {{ $t('explore.track') }}</p>
    </div>

    <n-modal v-model:show="modelStatus" preset="dialog" :show-icon="false">
      <template #header>
        <div class="header-wrap">
          <cover-name-code-normal :data="headerData" :showCode="false" />
        </div>
      </template>
      <model-base-layout :title="$t('explore.shareTrack')" decoLine cusHeader>
        <album-info :albumInfo="albumInfoData" :albumData="data" :description="description" padding />
      </model-base-layout>
    </n-modal>
  </div>
</template>
<script>
import { defineComponent, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { NModal } from 'naive-ui';
import dayjs from 'dayjs';
import MusicFunction from '@/components/Global/MusicPlayer/MusicFunction.vue';
import ModelBaseLayout from '@/components/Global/Popup/ModelBaseLayout.vue';
import AlbumInfo from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/AlbumInfo.vue';
import CoverNameCodeNormal from '@/components/Global/MusicPlayer/Fragment/CoverNameCodeNormal.vue';
import imageSource from '@/utils/imageSource';
import addCommas from '@/utils/addCommas';

export default defineComponent({
  name: 'PlaylistsAlbumsInfo',
  components: {
    MusicFunction,
    NModal,
    ModelBaseLayout,
    CoverNameCodeNormal,
    AlbumInfo,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    tracksLength: {
      type: Number,
      default: 0,
    },
    // labelsList: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  setup(props) {
    const modelStatus = ref(false);
    const route = useRoute();

    const openModal = () => {
      modelStatus.value = true;
    };

    const headerMockData = {
      title: 'GRAVITY - The Infinite Universe',
      desc: 'GTP252',
    };

    const description = computed(() => props.data.albumDescription || '');

    const labelsList = computed(() => {
      if (Array.isArray(props.data?.publisherAndLabel)) {
        return props.data?.publisherAndLabel.map((item) => ({
          labelUid: item.label.labelUid,
          name: item.label.labelNameDisplay,
          status: item.label.status,
        })).reduce((list, item) => {
          const existIdList = list.map((ele) => ele.labelUid);

          if (!existIdList.includes(item.labelUid)) {
            list.push(item);
          }

          return list;
        }, []);
      }

      return '';
    });

    const albumInfoData = computed(() => {
      if (props.data) {
        return [
          {
            title: 'Album',
            data: [props.data?.albumTitleDisplay],
          },
          // {
          //   title: 'Composer',
          //   data: [],
          //   // data: props.data?.composers.map(({ composer }) => composer.composerName),
          // },
          {
            title: 'Publishers',
            data: [props.data?.publisherAndLabel ? Array.from(new Set(props.data.publisherAndLabel.map((item) => item.publisher.publisherName))).join(', ') : ''],
            // data: props.data?.publishers.map(({ publisher }) => publisher.publisherName),
          },
          {
            title: 'Labels',
            data: [props.data?.publisherAndLabel ? Array.from(new Set(props.data.publisherAndLabel.map((item) => item.label.labelNameDisplay))).join(', ') : ''],
          },
        ];
      }
      return [];
    });

    const headerData = computed(() => ({ cover: props.data.artworkInfo || '', targetTitle: props.data.albumTitleDisplay }));

    const tags = computed(() => {
      if (props.data?.tags) {
        return props.data?.tags.map((item) => item.name).join(', ');
      }

      return '';
    });

    const albumsTags = computed(() => {
      if (props.data?.tags) {
        return props.data?.tags.filter((item) => item.tag).map((item) => {
          if (item.tag?.name) {
            return item.tag.name;
          }

          return '';
        }).join(', ') || '';
      }

      return '';
    });

    const releaseDate = (date) => dayjs(date).format('D MMM YYYY');

    return {
      route,
      modelStatus,
      openModal,
      albumInfoData,
      headerMockData,
      imageSource,
      tags,
      releaseDate,
      addCommas,
      albumsTags,
      description,
      headerData,
      labelsList,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-playlists-albums-info {}

.curr-music-title {
  margin-top: 20px;
  @include font-style($c-black, 18, bold, 0.9, 24px);
}

.curr-music-desc {
  display: none;
}

.curr-music-info {
  margin-top: 16px;

  &__label {
    @include font-style($c-assist3, 14, normal, 0, 24px);

  }

  &__id {
    @include font-style($c-assist6, 14, bold, 0, 24px);
    margin: 0 17px 0 10px;
  }

  &__labels {
    @include font-style($c-assist6, 14, normal, 0, 24px);
    margin-left: 10px;
    margin-right: 17px;

    &--active {
      text-decoration: underline;
    }

    &+& {
      margin-right: 10px;
    }
  }

  &__tags {
    @include font-style($c-assist6, 14, normal, 0, 24px);
    // text-decoration: underline;
    margin-left: 10px;
  }
}

.divide-line {
  width: 100%;
  height: 1px;
  background-color: $c-assist7;
  margin: 16px 0;
}

.music {
  @include flex(space-between);

  &__detail {
    &__music-player {
      display: inline-block;
    }

  }

  &__more-info {
    display: none;

    &__icon {
      cursor: pointer;
    }
  }

  &__other {
    display: none;
  }
}

.tracks {
  margin-top: 24px;

  &__text {
    @include font-style($c-assist3, 14, 600, 0.7px, 18px);
  }
}

.header-wrap {
  margin-left: 20px;
  margin-right: 50px;
}

@media screen and (min-width: $tablet) {
  .c-playlists-albums-info {}

  .curr-music-title {
    @include font-style($c-black, 35, bold, 0, 47px);
  }

  .curr-music-desc {
    display: block;
    margin-top: 16px;
    @include font-style($c-assist6, 14, normal, 0, 24px);
  }

  .curr-music-info {
    margin-top: 45px;

    &__label {
      @include font-style($c-assist3, 14, normal, 0, 24px);
    }

    &__id {
      @include font-style($c-assist6, 14, bold, 0, 24px);
      margin: 0 17px 0 10px;
    }

    &__labels {
      @include font-style($c-assist6, 14, normal, 0, 24px);
      margin-left: 10px;
    }
  }

  .divide-line {
    width: 100%;
    height: 1px;
    background-color: $c-assist7;
    margin: 16px 0;
  }

  .music {
    @include flex(space-between, flex-start);

    &__music-player {}

    &__more-info {
      display: none;
    }

    &__other {
      margin-left: 30px;
      display: block;

      &__detail {
        &__label {
          @include font-style($c-assist3, 14, normal, 0, 24px);
        }

        &__category {
          @include font-style($c-assist6, 14, normal, 0, 24px);
          margin: 0 20px 0 10px;
        }

        &__release-date {
          @include font-style($c-assist6, 14, normal, 0, 24px);
          margin-left: 10px;
        }
      }
    }
  }

  .tracks {
    margin-top: 38px;

    &__text {
      @include font-style($c-assist3, 14, 600, 0.7px, 18px);
    }
  }
}
</style>
